import { Log as LogScale } from '@antv/scale';
export const Log = (options) => {
    return new LogScale(options);
};
Log.props = {};
//# sourceMappingURL=log.js.map